export const attachId = (obj: { data: any, metadata: any }, fn: (entry: any) => string) => ({
  data: {
    ...obj?.data,
    id: fn(obj?.data),
  },
  metadata: {
    ...obj?.metadata,
    id: {
      hide: true,
      label: 'ID',
      editable: false,
    },
  },
});

export const attachIds = (obj: {data: any[], metadata: any}, fn: (entry: any) => string) => ({
  data: obj?.data?.map((data) => ({
    ...data,
    id: fn(data),
  })),
  metadata: {
    ...obj?.metadata,
    id: {
      hide: true,
      label: 'ID',
      editable: false,
    },
  },
});
